export enum LinkMode {
    PREVIEW = 'preview',
    TP = 'tp',
    NONE = 'none'
}

